import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Card back designs: one per-device preference for every card game (the backs are the shared visual,
 * the faces follow each game's own options like the four-colour deck). Pure CSS patterns — no assets,
 * so nothing to load and the goldens for games that pin ?carddesign are unaffected (the default is
 * and stays `classic`).
 */
export const CARD_DESIGNS = ['classic', 'stripes', 'dots', 'waves', 'pirate'] as const;
export type CardDesign = (typeof CARD_DESIGNS)[number];

export const CARD_DESIGN_NAMES: Record<CardDesign, string> = {
  classic: 'Classic',
  stripes: 'Stripes',
  dots: 'Dots',
  waves: 'Waves',
  pirate: 'Pirate',
};

interface CardDesignStore {
  readonly design: CardDesign;
  setDesign(design: CardDesign): void;
}

export const useCardDesignStore = create<CardDesignStore>()(
  persist(
    (set) => ({
      design: 'classic',
      setDesign(design) {
        set({ design });
      },
    }),
    { name: 's4k:card-design' },
  ),
);
